import React from 'react';
import './add salesTeam.css'
import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBIcon } from "mdbreact";
import "react-image-gallery/styles/css/image-gallery.css";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import allStrings from "../../assets/strings";
import { connect } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";
import { BASE_END_POINT } from "../../urls";
import axios from "axios";
import { message, TreeSelect } from "antd";
import { hasValue } from "../../validations/validations";
const { TreeNode } = TreeSelect;
class AddSalesTeam extends React.Component {
  state = {
    name: '',
    leader: null,
    employees: [],
  };

  constructor(props) {
    super(props)
    window.scrollTo(0, 0)
    if (this.props.isRTL) {
      allStrings.setLanguage('ar')
    } else {
      allStrings.setLanguage('en')
    }
  }

  componentDidMount() {
    this.getUserWithoutPagenation()
    if (this.props.isRTL) {
      allStrings.setLanguage('ar')
    } else {
      allStrings.setLanguage('en')
    }
  }
  getUserWithoutPagenation = () => {
    axios.get(`${BASE_END_POINT}quickSearch/get?type=SUB-ADMIN`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.props.currentUser.token}`,
        'Accept-Language': this.props.isRTL ? 'ar' : 'en',
      },
    }).then(response => {
      console.log(response.data.data)
      this.setState({ employees: response.data.data })
    })
      .catch(error => {
        console.log("ALL employees ERROR")
        console.log(error.response)
      })
  }

  add = () => {
    const { name, leader } = this.state
    if (hasValue(name) && leader != null) {
      let l = message.loading('Wait..', 2.5)
      let data = {
        "name": name,
        "leader": leader,
      }
      axios.post(`${BASE_END_POINT}salesTeams`, data, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${this.props.currentUser.token}`,
          'Accept-Language': this.props.isRTL ? 'ar' : 'en'
        },
      })
        .then(response => {
          console.log("dd salesTeam  ", response.data)
          l.then(() => message.success(allStrings.done, 2.5))
          this.props.history.goBack()
        })
        .catch(error => {
          console.log(error.response)
          l.then(() => message.error(error.response.data.errors[0].msg, 2.5))
        })
    }
  }
  changeHandler = event => {
    this.setState({ [event.target.name]: event.target.value });
  };
  submitHandler = event => {
    event.preventDefault();
    event.target.className += " was-validated";
    this.add()
  };
  render() {
    if (this.props.currentUser.user.type === "SUB-ADMIN" && !this.props.currentUser.user.permission.pages.includes('SALES-TEAMS')) return <Redirect to='/Home' />
    return (
      <div className="App">
        <MDBContainer>
          <MDBRow>
            <MDBCol md="12">
              <div className="infoCard">
                <Card className="editCard" style={{ overflow: 'visible', outline: 'none', marginBottom: '0px' }}>
                  <CardMedia
                    style={{ height: "0px" }}
                  />
                  <CardHeader></CardHeader>
                  <div style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row', display: 'flex' }}>
                    <div className="topIcon" style={{ background: 'linear-gradient(135deg, #1D9598, #127275)' }}>
                      <span class="material-icons" style={{ color: 'white', fontSize: 20 }}>contact_phone</span>
                    </div>
                    <div className="tableTitle" style={{
                      display: 'inline-block', marginTop: '-60px',
                      marginLeft: '0', marginRight: '0'
                    }}>
                      <p>{allStrings.addSalesTeam}</p>
                    </div>
                  </div>
                  <CardContent style={{ minHeight: "390px", outline: 'none' }}>
                    <MDBContainer>

                      <MDBRow>
                        <MDBCol md="12">
                          <form
                            className="needs-validation"
                            onSubmit={this.submitHandler}
                            noValidate
                          >
                            <div className="grey-text">
                              <MDBRow style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row' }}>
                                <MDBCol md="12">
                                  <div className="md-form">
                                    <label htmlFor="form65" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.name}</label>
                                    <input style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} value={this.state.name} type="text" id="form645" name="name" className="form-control" onChange={this.changeHandler} required validate placeholder="أدخل الاسم..." />
                                    <div class="valid-feedback">{allStrings.correct}</div>
                                    <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                  </div>
                                </MDBCol>
                              </MDBRow>
                              <MDBRow style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row' }}>
                                <MDBCol md="12">
                                  <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.leader}</label>
                                  <TreeSelect virtual={false}
                                    showSearch={true}
                                    style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                                    treeCheckable={false}
                                    treeNodeFilterProp="title"
                                    dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                    placeholder={allStrings.leader}
                                    onChange={(value) => {
                                      console.log(value)
                                      this.setState({ leader: value });
                                    }}

                                  >
                                    {this.state.employees.map(val => (
                                      <TreeNode value={val.id} title={val.fullname} key={val.id} />
                                    ))}
                                  </TreeSelect>
                                </MDBCol>
                              </MDBRow>

                            </div>
                            <br></br>
                            <br></br>
                            <div className="text-center">
                              <MDBBtn
                                style={{ background: 'linear-gradient(135deg, #1D9598, #127275)', color: '#fff' }}
                                rounded
                                color="#1D9598"
                                type="submit"
                                className="btn-block z-depth-1a"
                              >
                                <MDBIcon icon="plus" className="mr-2" />
                                {allStrings.add}
                              </MDBBtn>
                            </div>
                          </form>
                        </MDBCol>
                      </MDBRow>
                    </MDBContainer>
                  </CardContent>
                </Card>
              </div>
            </MDBCol>
          </MDBRow>

        </MDBContainer>

      </div>
    )
  }
}


const mapToStateProps = (state) => ({
  isRTL: state.lang.isRTL,
  currentUser: state.auth.currentUser,
});

const mapDispatchToProps = {
};

export default withRouter(
  connect(mapToStateProps, mapDispatchToProps)(AddSalesTeam)
);